import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArchive1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArchive1"><Path d="M22 3H2V7H22V3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 9H3V21H21V9ZM9 11H15V13H9V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArchive1;
